import styled, { css } from 'styled-components'
import { Image, Button } from '@sainsburys-tech/bolt'

const ProductReviewsHeader = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`

const ProductReviewsPreview = styled.div`
  display: inline-flex;
  margin-left: 10px;
`

const BVTrustmarkContainer = styled.span`
  display: flex;
  align-items: center;
  margin-left: 5px;
`

const TrustmarkMessage = styled.span`
  line-height: 1.5rem;
  text-transform: none;
  font-weight: 400;
  color: ${props => props.theme.color.monochrome.dark};
  margin: 0;
`

const RecomendationText = styled.span`
  margin-left: 3px;
  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        display: none;
      }
    `}
`

const BVLogo = styled(Image)`
  height: 30px;
  width: 80px;
  margin-left: 10px;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        display: none;
      }
    `}
`

const ReviewsSummaryContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        flex-direction: column;
      }
    `}
`

const ReviewsSummaryItem = styled.div`
  margin: 0px 10px;

  ${props =>
    props.child === 2 &&
    css`
      display: flex;
      flex: 1; /* Needed for iOS9/Safari 9 */
      width: 100%;
      flex-direction: column;
    `}

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        margin: 0px;
      }
    `}
`

const SortComponentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 1em;
  width: 100%;
`

const SortComponentWrapper = styled.span`
  width: 190px;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        margin-top: 10px;
        width: 100%;
      }
    `}
`

const ReviewsContainer = styled.div`
  margin-top: 20px;
`

const ReviewDivider = styled.span`
  display: flex;
  flex-direction: row;
  height: 1px;
  margin: 30px 0px;
  background-color: ${props => props.theme.color.monochrome.light};
`

const MoreReviewsButtonContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-anchor: none;
`

const MoreReviewsButtonText = styled.span`
  text-align: center;
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => props.theme.color.monochrome.dark};
`

const ProgressBarContainer = styled.span`
  width: 186px;
`
const WriteReviewButton = styled(Button)`
  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        margin-bottom: 10px;
      }
    `}
`
const NoReviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
  }
`
const NoReviewContent = styled.p`
  font-family: ${props => props.theme.font.family.base} !important;
  color: ${props => props.theme.color.palette['brand-1']} !important;
  font-weight: ${props => props.theme.font.weight.bold} !important;
  line-height: ${props => props.theme.font['line-height'].base} !important;
  margin: 0 5px 0 0 !important;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
    margin: 0 !important;
  }
`
const ReviewsText = styled.div`
  text-align: left;
  margin-right: 1em;
`

const Divider = styled.div`
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid ${props => props.theme.color.monochrome.base};
  text-align: center;
`

export {
  ProductReviewsHeader,
  ProductReviewsPreview,
  BVTrustmarkContainer,
  TrustmarkMessage,
  RecomendationText,
  BVLogo,
  ReviewsSummaryContainer,
  ReviewsSummaryItem,
  SortComponentContainer,
  SortComponentWrapper,
  ReviewsContainer,
  ReviewDivider,
  MoreReviewsButtonContainer,
  MoreReviewsButtonText,
  ProgressBarContainer,
  WriteReviewButton,
  NoReviewWrapper,
  NoReviewContent,
  ReviewsText,
  Divider
}
